var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n\n  button {\n    position: absolute;\n    right: 0;\n    bottom: $spacer;\n  }\n'], ['\n  position: relative;\n\n  button {\n    position: absolute;\n    right: 0;\n    bottom: $spacer;\n  }\n']);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/* eslint-disable max-len */

import React from 'react';
import Chart from 'chart.js';
import Chart2 from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';
import { merge, get } from 'lodash';
import html2canvas from 'html2canvas';
import styled from 'styled-components';
import { ButtonGroup } from 'reactstrap';
import { v4 as uuidv4 } from 'uuid';
import Button from './Button';
var color = Chart.helpers.color;
var COLOR_PATTERNS = [{
  color: '#6DB08F'
}, {
  color: '#F2C25E'
}, {
  color: '#72A8B2'
}, {
  color: '#A0AC62'
}, {
  color: '#D17D65'
}, {
  color: '#9C7F95'
}, {
  color: '#EEE5A0'
}];
var applyColors = function applyColors(data, chartType, options) {
  var isStacked = options.scales && options.scales.xAxes && options.scales.xAxes.length > 0 && options.scales.xAxes[0].stacked;

  // eslint-disable-next-line
  data.datasets = data.datasets.map(function (d, dsi) {
    if (chartType === 'line' || chartType === 'bar' && isStacked) {
      var colour = color(COLOR_PATTERNS[dsi % COLOR_PATTERNS.length].color);
      return _extends({
        backgroundColor: colour.alpha(0.9).hslString(),
        borderColor: colour.rgbString(),
        fill: options.fill,
        borderWidth: 2
      }, d);
    }
    return _extends({
      backgroundColor: d.data.map(function (dd, di) {
        return color(COLOR_PATTERNS[di % COLOR_PATTERNS.length].color).alpha(0.9).hslString();
      }),
      borderColor: d.data.map(function (dd, di) {
        return color(COLOR_PATTERNS[di % COLOR_PATTERNS.length].color).rgbString();
      })
    }, d);
  });
};
var Container = styled.div(_templateObject);
var ChartComponent = function ChartComponent(p) {
  var id = 'chart-' + uuidv4();
  var handleClip = function handleClip() {
    return html2canvas(document.getElementById(id)).then(function (canvas) {
      var link = document.createElement('a');
      link.href = canvas.toDataURL('image/jpeg');
      link.download = (p.title || 'My Chart') + '.jpeg';
      link.click();
    });
  };
  return React.createElement(Container, null, React.createElement(ButtonGroup, {
    size: 'sm',
    className: 'float-right'
  }, React.createElement(Button, {
    icon: 'cut',
    outline: true,
    onClick: handleClip
  }, 'Clip')), React.createElement('div', {
    id: id
  }, React.createElement(BaseChart, p)));
};
var BaseChart = function (_Chart) {
  _inherits(BaseChart, _Chart);
  function BaseChart() {
    _classCallCheck(this, BaseChart);
    return _possibleConstructorReturn(this, (BaseChart.__proto__ || Object.getPrototypeOf(BaseChart)).apply(this, arguments));
  }
  _createClass(BaseChart, [{
    key: 'renderChart',
    value: function renderChart() {
      var _props = this.props,
        legend = _props.legend,
        type = _props.type,
        plugins = _props.plugins,
        fill = _props.fill;
      var options = this.props.options;
      var node = this.element;
      var data = this.memoizeDataProps();
      if (legend && !('legend' in options)) {
        options.legend = legend;
      }
      if (fill && !('fill' in options)) {
        options.fill = fill;
      }
      applyColors(data, type, options);
      options = merge(options, {
        plugins: {
          datalabels: {
            display: get(options, 'plugins.datalabels.display', true)
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      });
      if (this.props.padding) {
        var padding = this.props.padding;
        if (typeof padding === 'string' || typeof padding === 'number') {
          options = merge(options, {
            layout: {
              padding: padding
            }
          });
        } else {
          options = merge(options, {
            layout: {
              padding: ['top', 'right', 'bottom', 'left'].reduce(function (full, memo) {
                /* eslint-disable-next-line */
                full[memo] = padding;
                return full;
              }, {})
            }
          });
        }
      } else {
        options = merge(options, {
          layout: {
            padding: 5
          }
        });
      }
      this.chartInstance = new Chart(node, {
        type: type,
        data: data,
        options: options,
        plugins: plugins
      });
    }
  }]);
  return BaseChart;
}(Chart2);
export default ChartComponent;
var chartifyDataSimple = function chartifyDataSimple(raw, labelKey, dataKey) {
  if (!raw) {
    return {
      labels: [],
      datasets: []
    };
  }
  return {
    labels: raw.map(function (r) {
      return r[labelKey];
    }),
    datasets: [{
      data: raw.map(function (r) {
        return r[dataKey];
      })
    }]
  };
};
export { chartifyDataSimple };